import { Check } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { SessionMedia } from "@/components/junior/SessionMedia";

const fmt = (h) => {
  const hr = Math.floor(h);
  const mins = h % 1 ? "30" : "00";
  return `${hr % 12 || 12}:${mins}${hr >= 12 ? "pm" : "am"}`;
};
export const sessionTime = (h) => (h == null ? "Time TBC" : `${fmt(h)} – ${fmt(h + 1.5)}`);
export const sessionDate = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short", year: "numeric" });

export const SessionChecklist = ({ sessions, setSessions, testKey, student }) => {
  const update = (i, patch) => setSessions(sessions.map((s, j) => (j === i ? { ...s, ...patch } : s)));
  return (
    <div className="space-y-3" data-testid={`junior-sessions-${testKey}`}>
      <p className="text-white/50 text-xs uppercase tracking-widest">Sessions · {sessions.filter((s) => s.attended).length} of {sessions.length} attended</p>
      {sessions.map((s, i) => (
        <div key={i} className={`rounded-xl border p-3 ${s.attended ? "border-lime-300/50 bg-lime-300/5" : "border-white/10"}`} data-testid={`junior-session-${testKey}-${i}`}>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <p className="text-white text-sm"><span className="font-semibold">Session {i + 1}</span> · {sessionDate(s.date)} · <span className="text-white/60">{sessionTime(s.start_hour)}</span></p>
            <button type="button" onClick={() => update(i, { attended: !s.attended })} data-testid={`junior-session-attended-${testKey}-${i}`}
              className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold transition-colors ${s.attended ? "bg-lime-300 text-black" : "border border-white/20 text-white/70 hover:border-white/50"}`}>
              <span className={`w-4 h-4 rounded flex items-center justify-center ${s.attended ? "bg-black text-lime-300" : "border border-white/40"}`}>{s.attended && <Check className="w-3 h-3" />}</span>
              {s.attended ? "Attended" : "Mark attended"}
            </button>
          </div>
          <Textarea rows={2} value={s.feedback} onChange={(e) => update(i, { feedback: e.target.value })} placeholder="Feedback for this session (parents can read this)"
            className="mt-2 bg-dream-surface border-dream-border text-white text-sm" data-testid={`junior-session-feedback-${testKey}-${i}`} />
          {student && <SessionMedia student={student} index={i} media={s.media} onChange={(media) => update(i, { media })} testKey={testKey} />}
        </div>
      ))}
    </div>
  );
};
